type Props = {
  onOpenConsult: () => void;
};

export default function SectionHero({ onOpenConsult }: Props) {
  return (
    <section id="top" className="relative pt-24 md:pt-28 pb-10 md:pb-14 bg-white">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-[1440px] mx-auto">
          <div className="hero-copy grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
            <div className="lg:col-span-8">
              <div className="text-ds-eyebrow text-brand mb-5">
                Private Dentistry · Est. 2011
              </div>
              <h1 className="text-ds-display text-ink font-semibold">
                Private dentistry
                <br />
                <span className="text-brand">designed around you.</span>
              </h1>
              <p className="mt-6 max-w-[520px] text-ds-body text-ink-muted">
                Natural results, clear treatment planning and a calmer private dental experience — from consultation to follow-up.
              </p>
            </div>
            <div className="lg:col-span-4 flex flex-col gap-4 lg:items-end">
              <div className="flex flex-wrap gap-3">
                <a
                  href="#concern"
                  className="inline-flex items-center gap-2 px-5 py-3 rounded-md border border-gray-300 text-ds-control font-medium text-ink hover:border-ink transition whitespace-nowrap cursor-pointer"
                >
                  Find the Right Treatment
                  <i className="ri-arrow-right-line text-sm" />
                </a>
              </div>
              <div className="grid grid-cols-2 gap-x-6 gap-y-1.5 text-ds-caption text-ink-muted mt-2">
                <div className="flex items-center gap-2"><span className="w-1 h-1 rounded-full bg-brand" />Private Consultation</div>
                <div className="flex items-center gap-2"><span className="w-1 h-1 rounded-full bg-brand" />Personalized Plans</div>
                <div className="flex items-center gap-2"><span className="w-1 h-1 rounded-full bg-brand" />Digital Diagnostics</div>
                <div className="flex items-center gap-2"><span className="w-1 h-1 rounded-full bg-brand" />Flexible Booking</div>
              </div>
            </div>
          </div>

          {/* Hero image slot */}
          <div className="mt-10 md:mt-14">
            <div
              data-slot="hero"
              className="w-full aspect-[16/8] md:aspect-[16/7] rounded-[16px] overflow-hidden"
              style={{ background: "transparent", boxShadow: "none" }}
            />
            <div className="mt-4 flex items-center justify-between text-ds-caption text-ink-muted">
              <span>Aline Dental · Consultation Room 02</span>
              <span className="hidden sm:flex items-center gap-2">
                Scroll <i className="ri-arrow-down-line" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}